module.exports = __webpack_public_path__ + "img/hero.81fa40c9.png";